<template>
  <svg
    class="hero-court-illustration"
    viewBox="0 0 720 620"
    preserveAspectRatio="xMidYMid slice"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="home-court-bg" x1="0" y1="0" x2="1" y2="1">
        <stop stop-color="#183d2c" />
        <stop offset="1" stop-color="#0c271b" />
      </linearGradient>
      <linearGradient id="home-court-blue" x1="0" y1="0" x2="0" y2="1">
        <stop stop-color="#397c8c" />
        <stop offset="1" stop-color="#246575" />
      </linearGradient>
      <filter id="home-court-shadow" x="-30%" y="-30%" width="170%" height="180%">
        <feDropShadow dx="0" dy="21" stdDeviation="20" flood-color="#061b12" flood-opacity=".36" />
      </filter>
      <pattern id="home-net-mesh" width="13" height="9" patternUnits="userSpaceOnUse">
        <path d="M0 0L13 9M13 0L0 9" stroke="#e6ece8" stroke-width=".5" opacity=".38" />
      </pattern>
    </defs>

    <rect width="720" height="620" fill="url(#home-court-bg)" />
    <path d="M0 450Q180 390 360 452T720 444V620H0Z" fill="#2d6144" opacity=".18" />

    <g transform="rotate(-4 360 320)" filter="url(#home-court-shadow)">
      <path d="M154 98 L566 98 L632 510 L88 510 Z" fill="#397e57" stroke="#6e9b7e" stroke-width="2" />
      <path d="M188 128 L532 128 L590 478 L130 478 Z" fill="url(#home-court-blue)" />

      <!-- 双打边线与底线 -->
      <path d="M188 128 L532 128 L590 478 L130 478 Z" fill="none" stroke="#fffdf1" stroke-width="3" />
      <!-- 单打边线；单打宽 8.23m，双打宽 10.97m -->
      <path d="M231 128 L188 478 M489 128 L532 478" fill="none" stroke="#fffdf1" stroke-width="2.5" />
      <!-- 发球线与中央发球线 -->
      <path d="M211 190 L509 190 M165 382 L555 382" fill="none" stroke="#fffdf1" stroke-width="2.5" />
      <path d="M360 190 L360 382" stroke="#fffdf1" stroke-width="2.5" />
      <!-- 底线中心标 -->
      <path d="M360 128V137 M360 469V478" stroke="#fffdf1" stroke-width="2.5" />

      <!-- 带网带、网柱和中心带的球网 -->
      <path d="M153 289 L567 289 L570 323 L150 323 Z" fill="url(#home-net-mesh)" stroke="#dfe7df" stroke-width="1.2" />
      <path d="M153 289 L567 289" stroke="#fff8db" stroke-width="5" />
      <path d="M152 282V329 M568 282V329" stroke="#dfe7df" stroke-width="6" />
      <path d="M360 291V324" stroke="#f6f3e8" stroke-width="2.5" />

      <circle cx="218" cy="429" r="7" fill="#fbdb13" stroke="#173e2d" stroke-width="2" />
      <circle cx="485" cy="163" r="5" fill="#fbdb13" stroke="#173e2d" stroke-width="1.5" />
    </g>
  </svg>
</template>
